import {
  trigger,
  state,
  transition,
  style,
  animate,
  group,
} from '@angular/animations';

export const slideInOut = trigger('slideInOut', [
  state('in', style({ height: '*', opacity: 0 })),
  transition(':leave', [
    style({ height: '*', opacity: 1 }),

    group([
      animate(200, style({ height: 0 })),
      animate('200ms ease-in-out', style({ opacity: '0' })),
    ]),
  ]),
  transition(':enter', [
    style({ height: '0', opacity: 0 }),

    group([
      animate(200, style({ height: '*' })),
      animate('200ms ease-in-out', style({ opacity: '1' })),
    ]),
  ]),
]);

export const slide = trigger('slide', [
  state('in', style({ height: '*' })),
  transition(':leave', [
    style({ height: '*' }),

    group([animate(200, style({ height: 0 }))]),
  ]),
  transition(':enter', [
    style({ height: '0' }),

    group([animate(200, style({ height: '*' }))]),
  ]),
]);

export const slideOut = trigger('slideOut', [
  state('in', style({ height: '*', opacity: 0 })),
  transition(':leave', [
    style({ height: '*', opacity: 1 }),

    group([
      animate(0, style({ height: 0 })),
      animate('0ms', style({ opacity: '0' })),
    ]),
  ]),
  transition(':enter', [
    style({ height: '0', opacity: 0 }),

    group([
      animate(200, style({ height: '*' })),
      animate('200ms ease-in-out', style({ opacity: '1' })),
    ]),
  ]),
]);

export const fadeInOut = trigger('fadeInOut', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate('0ms 200ms', style({ opacity: 1 })),
  ]),
  transition(':leave', [animate('0ms 200ms', style({ opacity: 0 }))]),
]);
